// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__2BXXY","logo":"Error_logo__1mw5D"};